import { atom } from "jotai";
import { growthExpenseItemsAtom, isGrowthCapExIncludedAtom } from "./general";
import { createComputedIterationMolecule } from "./iterations";

export const cashFlowGrowthCapExMolecules = atom((get) => {
  const items = get(growthExpenseItemsAtom);

  const isGrowthCapExIncluded = get(isGrowthCapExIncludedAtom);

  if (!isGrowthCapExIncluded) {
    return [];
  }

  return items.map((item) => {
    return {
      label: item.name,
      molecule: createComputedIterationMolecule((_i, iter) => {
        return atom(() => {
          return {
            type: "dollar" as const,
            isNegative: true,
            isLocked: true,
            value: iter === item.start ? item.amount : 0,
          };
        });
      }),
    };
  });
});

export const cashFlowGrowthCapExTotalMolecule = createComputedIterationMolecule(
  (_i, iter) => {
    return atom((get) => {
      const items = get(growthExpenseItemsAtom);
      const isGrowthCapExIncluded = get(isGrowthCapExIncludedAtom);

      if (!isGrowthCapExIncluded) {
        return {
          type: "dollar" as const,
          //isNegative: true,
          isLocked: true,
          value: 0,
        };
      }

      const total = items.reduce((acc, item) => {
        return acc + (iter === item.start ? item.amount : 0);
      }, 0);

      return {
        type: "dollar" as const,
        isNegative: true,
        isLocked: true,
        value: total,
      };
    });
  },
);

export const operatingGrowthCapExMolecules = atom((get) => {
  const items = get(growthExpenseItemsAtom);

  const isGrowthCapExIncluded = get(isGrowthCapExIncludedAtom);

  if (!isGrowthCapExIncluded) {
    return [];
  }

  return items.map((item) => {
    return {
      label: item.name,
      molecule: createComputedIterationMolecule((_i, iter) => {
        return atom(() => {
          return {
            type: "dollar" as const,
            isNegative: true,
            isLocked: true,
            value:
              iter >= item.start && iter < item.start + item.duration
                ? item.amount / item.duration
                : 0,
          };
        });
      }),
    };
  });
});

export const operatingGrowthCapExTotalMolecule =
  createComputedIterationMolecule((_i, iter) => {
    return atom((get) => {
      const items = get(growthExpenseItemsAtom);
      const isGrowthCapExIncluded = get(isGrowthCapExIncludedAtom);

      if (!isGrowthCapExIncluded) {
        return {
          type: "dollar" as const,
          isNegative: true,
          isLocked: true,
          value: 0,
        };
      }

      const total = items.reduce((acc, item) => {
        return (
          acc +
          (iter >= item.start && iter < item.start + item.duration
            ? item.amount / item.duration
            : 0)
        );
      }, 0);

      return {
        type: "dollar" as const,
        isNegative: true,
        isLocked: true,
        value: total,
      };
    });
  });
